module.exports = __webpack_public_path__ + "static/media/loading.1b1a27ca.gif";


//////////////////
// WEBPACK FOOTER
// ./src/loading.gif
// module id = 57
// module chunks = 0